"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Image from "next/image";
import Link from "next/link";

export default function PageNotFound() {
  return (
    <Container>
      <Grid container spacing={2} size={{ xs: 12 }} alignItems={"center"}>
        <Grid container spacing={2} size={{ xs: 12, md: 6 }} order={{ xs: 2, md: 1 }}>
          <Box
            sx={{
              position: "relative",
              height: { xs: "300px", sm: "400px", md: "500px" },
              width: "100%",
              mt: { xs: "3rem", md: "3rem" },
            }}
          >
            <Image
              src="/images/others/page-not-found.png"
              alt="Page not found"
              fill
              loader={({ src }) => src}
              unoptimized
              style={{
                objectFit: "contain",
              }}
            />
          </Box>
        </Grid>
        <Grid
          container
          spacing={2}
          size={{ xs: 12, md: 6 }}
          justifyContent={"center"}
          order={{ xs: 1, md: 2 }}
        >
          <Box sx={{ width: "fit-content" }}>
            <Box
              sx={{
                display: "flex",
                gap: "10px",
                justifyContent: { xs: "center", md: "flex-start" },
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "3rem",
                    sm: "4rem",
                    md: "4.2rem",
                    lg: "5rem",
                  },
                  fontWeight: 600,
                  textShadow: "0px 0px 8px rgba(55 55 55 / 0.3)",
                  fontFamily: "'blauerNue', 'blauerNue Fallback'",
                  color: "#C00008",
                }}
              >
                Oops!
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "3rem",
                    sm: "4rem",
                    fontFamily: "'blauerNue', 'blauerNue Fallback'",
                    md: "4.2rem",
                    lg: "5rem",
                  },
                  fontWeight: 600,
                  textShadow: "0px 0px 8px rgba(55 55 55 / 0.3)",
                  color: "#18147D",
                }}
              >
                Sorry
              </Typography>
            </Box>

            <Typography
              sx={{
                fontSize: { xs: "0.9rem", sm: "1rem" },
                fontWeight: 400,
                color: "#444",
                textAlign: { xs: "center", md: "left" },
                mt: { xs: "1rem", sm: "0rem" },
              }}
            >
              We can&apos;t seem to find the page you&apos;re looking for.
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: { xs: "10px", sm: "15px", md: "10px" },
                mt: { xs: "2rem", sm: "1.5rem", md: "3rem" },
                justifyContent: { xs: "center", md: "flex-start" },
              }}
            >
              <Link href="/" passHref>
                <Box
                  sx={{
                    fontSize: "1rem",
                    bgcolor: "#060273",
                    color: "#fff",
                    textDecoration: "none",
                    fontFamily: "'blauerNue', 'blauerNue Fallback'",
                    p: "6px 18px 7px",
                    borderRadius: "8px",
                  }}
                >
                  Go Home
                </Box>
              </Link>
              <Link href="/contact-us" passHref>
                <Box
                  sx={{
                    fontSize: "1rem",
                    color: "#1f1f1f",
                    textDecoration: "none",
                    p: "6px 18px 7px",
                    borderRadius: "8px",
                    fontFamily: "'blauerNue', 'blauerNue Fallback'",
                    border: "1px solid #aaa",
                  }}
                >
                  Contact Us
                </Box>
              </Link>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
